export default {
  APP_NAME: 'yola-editor',
  EDITOR_PRODUCT_CATEGORY: 'latitude',
};
